/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SVGIcon, useThemeSwitcher, THEME_OPTIONS } from "@nordcloud/gnui";
import { useAuth0 } from "~/services/auth";
import { DropList, DropButton, IconWrap, DropItem } from "../../styles";
import { UserName } from "./styles";

type Props = {
  userName: string;
};

export function UserDropdown({ userName }: Props) {
  const { currentTheme, setTheme } = useThemeSwitcher();
  const { logout } = useAuth0();

  const nextTheme = currentTheme === THEME_OPTIONS.LIGHT ? THEME_OPTIONS.DARK : THEME_OPTIONS.LIGHT;

  return (
    <DropList>
      <UserName>{userName}</UserName>
      <DropItem>
        <DropButton data-cy="color-mode" onClick={() => setTheme(nextTheme)}>
          <IconWrap>
            <SVGIcon name="dashboard" />
          </IconWrap>
          Switch to {THEME_OPTIONS[nextTheme].toLowerCase()} mode
        </DropButton>
      </DropItem>
      <DropItem>
        <DropButton
          onClick={() => {
            logout({
              returnTo: window.location.origin,
            });
            window.localStorage.removeItem("klairtyCustomerId");
          }}
        >
          <IconWrap>
            <SVGIcon name="logout" />
          </IconWrap>
          Logout
        </DropButton>
      </DropItem>
    </DropList>
  );
}
